import React, { useEffect, useState } from 'react';
import { Fab } from '@mui/material';
import ArrowUpIcon from '@mui/icons-material/ArrowUpward';
import './ScrollToTopButton.css';
import { useTheme } from '@mui/material/styles';

const ScrollToTopButton = () => {
  const theme = useTheme();
  const [showScroll, setShowScroll] = useState(false);

  const getShouldShowButton = () => {
    window.pageYOffset > 500 ? setShowScroll(true) : setShowScroll(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', getShouldShowButton);
    return () => {
      window.removeEventListener('scroll', getShouldShowButton);
    };
  }, []);

  return (
    <div className="scroll-to-top" onClick={scrollToTop}>
      {showScroll && (
        <div>
          <Fab
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            <ArrowUpIcon fontSize="large" />
          </Fab>
        </div>
      )}
    </div>
  );
};

export default ScrollToTopButton;
